import { ToastType } from '../constants';
import { CLOSE_MODAL, OPEN_MODAL } from '../constants/action-types';
import { AngularServices, canUseBackgroundEffects, getAngularService, localeService, } from '../helpers';
import { addToast } from './toasts';
export const openModal = (modal) => ({
    type: OPEN_MODAL,
    payload: modal,
});
export const closeModal = () => ({
    type: CLOSE_MODAL,
});
export const openBackgroundEffectsModal = (context) => (dispatch, getState) => {
    let trackingButtonText = null;
    let trackingButtonAction = null;
    if (canUseBackgroundEffects()) {
        dispatch(openModal('BackgroundEffects'));
        trackingButtonText = 'Open background effects modal';
    }
    else {
        const warningMessageId = `backgroundEffects.notifications.upgrade${getState().callInfo.callSession?.isInCall ? '.inCall' : ''}`;
        const warningMessage = localeService.formatMessageById(warningMessageId);
        dispatch(addToast(ToastType.warning, warningMessage, 10000));
        trackingButtonText = 'Attempt to open background effects modal';
        trackingButtonAction = 'upgrade';
    }
    const trackingFactory = getAngularService(AngularServices.TrackingFactory);
    trackingFactory.global.trackButtonClick({
        button_text: trackingButtonText,
        button_action: trackingButtonAction,
        context,
    });
};
